// extracted by mini-css-extract-plugin
export default {"linkCard":"LinksCard_linkCard__fOQd0","divider":"LinksCard_divider__wy9Sh","link":"LinksCard_link__N+mlx"};